import { getAddress } from 'viem';
import TonWeb from 'tonweb';
import { Address } from '@multiversx/sdk-core';

/**
 * Check if EVM address
 * @param input - address
 * @returns - boolean
 */
const isEVMAddress = (contractAddress: string): boolean => {
  const regex = /^0x[a-fA-F0-9]{40}$/;
  return regex.test(contractAddress);
};

/**
 * Check if Elrond address
 * @param input - address
 * @returns - boolean
 */
const isElrondAddress = (contractAddress: string): boolean => {
  try {
    const parsedAddress = new Address(contractAddress);
    return !!parsedAddress.toString();
  } catch (error) {
    return false;
  }
};

/**
 * Check if Tron address
 * @param input - address
 * @returns - boolean
 */
const isTronAddress = (contractAddress: string): boolean => {
  const regex = /^T[a-zA-Z0-9]{33}$/;
  return regex.test(contractAddress);
};

/**
 * Check if Ton address
 * @param input - address
 * @returns - boolean
 */
const isTonAddress = (contractAddress: string): boolean => {
  try {
    const parsedAddress = new TonWeb.Address(contractAddress);
    return !!parsedAddress.toString(false);
  } catch (error) {
    return false;
  }
};

/**
 * If EVM, checksum address or return initial one
 * @param input - address
 * @returns - checksummed address
 */
const toChecksumAddressWrapper = (input: string): string => {
  try {
    if (isEVMAddress(input)) {
      return getAddress(input);
    }
    return input;
  } catch (e) {
    console.warn(input + ' is not a valid Ethereum address.');
    return input;
  }
};

export {
  isEVMAddress,
  isElrondAddress,
  isTronAddress,
  isTonAddress,
  toChecksumAddressWrapper,
};
